/**
 * <holiday-gift>: meldt één keer per pagina dat het cadeaublok echt in beeld kwam
 * (holiday_block_view, voor het meetplan: orders met kerst/Sint-timing met het blok aan).
 * Pas bij de helft in beeld, zodat een blok dat alleen langs de rand scrolt niet telt.
 */
class HolidayGift extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    if (window.__holidayGiftSeen) return;
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || window.__holidayGiftSeen) return;
        window.__holidayGiftSeen = true;
        this.#observer?.disconnect();
        try {
          window.Shopify?.analytics?.publish('holiday_block_view', {
            placement:
              this.dataset.placement || (this.classList.contains('holiday-gift--compact') ? 'cart' : 'pdp'),
          });
        } catch (error) {
          // tracking mag nooit in de weg zitten
        }
      },
      { threshold: 0.5 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('holiday-gift')) {
  customElements.define('holiday-gift', HolidayGift);
}
